import React from "react";
import {
  ContentFormatter,
  Dialog,
  DialogTitle,
  DialogTitleActions,
  Icon,
  Type,
} from "discover.medical.react-component-library";
import { logBoxedWarningsClicked } from "../../util/analytics";
import { useEventBus } from "../../util/useEventBus";

import {
  BoxedWarningButton,
  StyledBoxedWarningTitle,
  StyledTitleFlex,
  StyledContentFlex,
} from "./_.styled";
import { CTA_TRIGGER_ACTION, useLaunchCTA } from "../../hooks/useLaunchCTA";

const BoxedWarning = ({
  drugTitle,
  boxedWarnings,
  isBoxedWarningOpen,
  setIsBoxedWarningOpen,
  telemetryData,
  isPreviewMode,
}) => {
  const eventBus = useEventBus();
  const { launchCTA } = useLaunchCTA({ eventBus });

  const handleBoxedWarningCancel = () => {
    setIsBoxedWarningOpen(false);
  };
  return (
    <>
      <BoxedWarningButton
        kind="anchor"
        onClick={() => {
          if (isPreviewMode) {
            launchCTA({ userAction: CTA_TRIGGER_ACTION.BOXED_WARNING_CLICK });
          } else {
            setIsBoxedWarningOpen(true);
            logBoxedWarningsClicked(telemetryData);
          }
        }}
        data-testid="boxed-warning-button"
      >
        <Icon
          icon={{
            color: "red",
            glyph: "warning",
            size: "md",
          }}
        />
        {boxedWarnings?.label}
      </BoxedWarningButton>
      <Dialog
        isOpen={isBoxedWarningOpen}
        data-testid="boxed-warning-dialog"
        aria-labelledby="boxed-warning-dialog"
        onRequestClose={handleBoxedWarningCancel}
        maxWidth="lg"
      >
        <DialogTitle>
          <StyledTitleFlex container align={{ item: "center" }}>
            <StyledBoxedWarningTitle
              element="p"
              data-testid="boxed-warning-dialog-title"
              fontWeight="bold"
              paddingLeft="xl"
            >
              <Icon
                icon={{
                  color: "red",
                  glyph: "warning",
                  size: "md",
                }}
              />
              &nbsp;{boxedWarnings?.label}
            </StyledBoxedWarningTitle>
          </StyledTitleFlex>
          <DialogTitleActions
            isFloating
            onRequestClose={handleBoxedWarningCancel}
          />
        </DialogTitle>
        <StyledContentFlex
          borderTopColor="gray300"
          borderTopStyle="solid"
          borderTopWidth="1px"
          paddingLeft="xxxl"
          paddingRight="xxxl"
        >
          <Type
            element="h2"
            fontWeight="bold"
            fontFamily="secondary"
            paddingTop="md"
            paddingBottom="lg"
            data-testid="boxed-warning-drug-title"
          >
            {drugTitle}
          </Type>
          {boxedWarnings?.value &&
            boxedWarnings.value.map((value) => (
              <>
                <Type
                  element="h4"
                  fontWeight="bold"
                  fontFamily="secondary"
                  paddingBottom="sm"
                  data-testid="boxed-warning-heading"
                >
                  {value.heading}
                </Type>
                {value.warnings &&
                  value.warnings.map((warning) => (
                    <Type
                      paddingBottom="lg"
                      data-testid="boxed-warning-warning-content"
                    >
                      <ContentFormatter>{warning}</ContentFormatter>
                    </Type>
                  ))}
              </>
            ))}
        </StyledContentFlex>
      </Dialog>
    </>
  );
};

BoxedWarning.displayName = "BoxedWarning";
export default BoxedWarning;
